import React, { useState } from 'react';
import Popup from "../imagepopup";


function Aspirezone() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };

  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p19.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                As a UI/UX Designer, I played a key role in designing and developing applications for Aspire Academy and Aspire Zone, including the FIFA Ticketing System in Qatar. Focused on delivering intuitive, high-performance, and user-centric digital platforms, ensuring seamless experiences for users across sports management, training, and ticketing applications.
                </p>
                <p className="mt-15">
                Designed and developed interactive dashboards, ticketing portals, and athlete management systems, enhancing user engagement and operational efficiency. Leveraged wireframing, prototyping, and front-end technologies to create visually appealing and functionally robust applications.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Designer</strong>, I was responsible for:</p>
                 
                  
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      User Research & Experience Design: Conducted user analysis, persona creation, and usability testing to craft intuitive interfaces.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Wireframing & Prototyping: Created interactive wireframes and prototypes using Adobe Photoshop, and Axure to define user flows and design interactions.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Ticketing & Event Management UI: Designed an efficient FIFA ticketing system UI, ensuring a seamless booking experience for global users.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Sports & Athlete Management Portals: Developed data-driven dashboards for Aspire Academy, providing real-time insights into athlete training and performance.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Mobile-Responsive & Cross-Platform UI: Designed mobile-friendly and cross-browser-compatible interfaces using HTML, CSS, JavaScript, and Bootstrap.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Branding & Visual Aesthetics: Ensured all UI designs adhered to Aspire Academy and Aspire Zone branding guidelines, delivering a premium and professional digital experience.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance & Accessibility Optimization: Implemented WCAG accessibility standards and optimized UI components for fast performance.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Cross-Functional Teams: Worked onsite in Qatar, collaborating with developers, product owners, and FIFA stakeholders to align UI/UX goals with business requirements.
                      </h6>
                    </li>
                  </ul>
                  
                  <p className="mt-25">
                  This project contributed to delivering a world-class digital experience for sports management, ticketing, and event planning, enhancing Aspire’s role in global sporting events and optimizing their digital transformation initiatives.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>July 2011</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Designer</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Aspire</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p17.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p17.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p18.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p18.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p14.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p14.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/deloitte">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/sony">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
            
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Aspirezone;
